export default class InifinteQueue {
  items = [];

  constructor(items) {
    if (items) this.items = items;
  }

  enqueue(item) {
    this.items.push(item);
  }

  dequeue() {
    const item = this.items.shift();

    this.enqueue(item);

    return item;
  }

  peek() {
    return this.items[0];
  }
}



// WEBPACK FOOTER //
// ./src/helpers/InfiniteQueue.js